module.exports = __webpack_public_path__ + "static/media/tripwire.e0c4488d.png";